import { fetcher } from 'services/helpers/responseHandler'

const buyNumber = async ({ numbersToBuy, subsidiaryId }) =>
  fetcher.post(`telcosetup`, { numbersToBuy, subsidiaryId })

const numberSearch = async ({ areaCode, pattern, zipCode }) =>
  fetcher.post(`telconumberssearch`, { areaCode, pattern, zipCode })

const campaignImportPhoneNumber = async ({ subsidiaryId }) =>
  fetcher.post('telcosetup/campaign-number-association', { subsidiaryId })

const telcoApi = {
  buyNumber,
  numberSearch,
  campaignImportPhoneNumber
}

export default telcoApi
